import { render, staticRenderFns } from "./lawyer-choi-head.vue?vue&type=template&id=62dbd5b0"
import script from "./lawyer-choi-head.vue?vue&type=script&lang=js"
export * from "./lawyer-choi-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports